import { JAB } from '../cards/attack/jab';
import { POWER_STRIKE } from '../cards/attack/power-strike';
import type { EnemyTemplate } from './template';

/** HEX-23 archetype ported to the card schema (ADR-0015 §4, §15). Common tier:
 * 2×2 grid, 2 dice, two common attack cards. */
export const GOBLIN_STRIKER: EnemyTemplate = {
  id: 'goblin-striker',
  name: 'Goblin Striker',
  glyph: '♞', // knight — a darting melee striker
  tier: 'common',
  hp: 12,
  loadout: [
    { card: POWER_STRIKE, origin: { row: 0, col: 0 }, rotated: false },
    { card: JAB, origin: { row: 1, col: 0 }, rotated: false },
  ],
  drops: { gold: 5 },
};
